const selectElements = document.getElementsByClassName("select__select");

// Convert HTMLCollection to an array and loop through each element
Array.from(selectElements).forEach((selectElement) => {
  selectElement.addEventListener("change", (event) => {
    console.log("222222222");

    var oldVariant = document
      .getElementsByClassName("axt-cp-custom")[0]
      .getAttribute("axt-cp-variant-id");

    setTimeout(() => {
      var variantId = document.querySelector('[name="id"]').value;
      var customElement = document.getElementsByClassName("axt-cp-custom")[0];

      if (customElement) {
        customElement.classList.add(variantId);
        customElement.classList.remove(oldVariant);
        customElement.setAttribute("axt-cp-variant-id", variantId);
      }
    }, 700);
  });
});
